import { IBM_REFRESH_CERTIFICATE_SLUGS } from 'bundles/unified-description-page-common/utils/shouldShowNewAiSkillsBadge';

import _t from 'i18n!nls/xdp';

export const getPartnerRefreshAiBadgeTitle = (slug?: string): string => {
  if (slug === 'java-developer') {
    return _t('New AI skills!');
  }
  if (slug && IBM_REFRESH_CERTIFICATE_SLUGS.includes(slug)) {
    return _t('New GenAI skills');
  }
  return _t('New AI skills');
};

export default getPartnerRefreshAiBadgeTitle;
